import { faPhone } from "@fortawesome/free-solid-svg-icons/faPhone"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
    ActionBannerWithButton,
    ColorSchemes,
    componentStyles,
    TextSmall,
    useActionBannerColors,
} from "@mallardbay/lib-react-components"
import React from "react"

import { SUPPORT_CONTACTS } from "~config/constants"
import COPY from "~config/copy-constants"
import { TEST_IDS } from "~config/test-ids"
import { showHubspotChat } from "~utils/hubspot-hooks"

interface Props {
    readonly shouldShowEmail?: boolean
}

export default function ContactSupportBanner({
    shouldShowEmail = false,
}: Props) {
    const styles = useStyles()

    return (
        <ActionBannerWithButton
            title={COPY.SUPPORT_BANNER_TITLE}
            description={COPY.SUPPORT_BANNER_DESCRIPTION}
            buttonLabel={COPY.SUPPORT_BANNER_BUTTON_LABEL}
            buttonOnClick={() => showHubspotChat(true)}
            colorScheme={ColorSchemes.Blue}
            testId={TEST_IDS.CONTACT_SUPPORT_BANNER}
        >
            <TextSmall style={styles.text}>
                <FontAwesomeIcon icon={faPhone} style={styles.text} />
                {` ${COPY.SUPPORT_BANNER_DESCRIPTION_2} `}
                <b>{SUPPORT_CONTACTS.PHONE}</b>
                {shouldShowEmail && (
                    <>
                        {` ${COPY.AND} `}
                        <b>{SUPPORT_CONTACTS.EMAIL}</b>
                    </>
                )}
            </TextSmall>
        </ActionBannerWithButton>
    )
}

function useStyles() {
    const { descriptionColor } = useActionBannerColors({
        colorScheme: ColorSchemes.Blue,
    })

    return componentStyles({ text: { color: descriptionColor } })
}
